<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Map Action With Role</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group" [hidden]="notAdmin">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected"
              (change)="onClientChange($event.target.selectedIndex)">
        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="roleSelected" (change)="onRoleChange($event.target.selectedIndex)">
        <option *ngFor="let rl of role" [value]="rl.id">{{rl.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="metaTableSelected" (change)="onTableChange($event.target.selectedIndex)">
        <option *ngFor="let table of tables" [value]="table.id">{{table.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="metaTableFieldSelected" (change)="onTableFieldChange($event.target.selectedIndex)">
        <option *ngFor="let tableField of tableFields" [value]="tableField.id">{{tableField.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="urlSelected" (change)="onUrlChange($event.target.selectedIndex)">
        <option *ngFor="let url of urls" [value]="url.id">{{url.name}}</option>
      </select>
    </div>
    <div class="form-group font-13">
      <mat-checkbox *ngFor="let action of actions" value="{{action.id}}" [(ngModel)]="action.checked">{{action.name}}</mat-checkbox>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
